export const LOAD_CLINIC_INFORMATION = 'LOAD_CLINIC_INFORMATION';
export type LOAD_CLINIC_INFORMATION = typeof LOAD_CLINIC_INFORMATION;

export const CLEAN_SITE_INFORMATION = 'CLEAN_SITE_INFORMATION';
export type CLEAN_SITE_INFORMATION = typeof CLEAN_SITE_INFORMATION;



// WEBPACK FOOTER //
// ./src/store/ClinicInformation/constants.ts